import { render, staticRenderFns } from "./frontView.vue?vue&type=template&id=4418981a&scoped=true&"
import script from "./frontView.vue?vue&type=script&lang=js&"
export * from "./frontView.vue?vue&type=script&lang=js&"
import style0 from "./frontView.vue?vue&type=style&index=0&id=4418981a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4418981a",
  null
  
)

export default component.exports